// extracted by mini-css-extract-plugin
export var cardsGrid = "Resources-module--cardsGrid--xM9Xf";
export var noResults = "Resources-module--noResults--R2avN";
export var resourcesSection = "Resources-module--resourcesSection--LRXId";
export var sectionHeader = "Resources-module--sectionHeader--qIKSw";
export var sectionSubtitle = "Resources-module--sectionSubtitle--YFr5w";
export var sectionTitle = "Resources-module--sectionTitle--Fy472";